import React from 'react';
import './SocialProofStats.css';

const SocialProofStats: React.FC = () => {
  const stats = [
    { value: '500+', label: 'Zadowolonych uczniow', icon: 'users' },
    { value: '98%', label: 'Zdawalnosc matur', icon: 'check' },
    { value: '+35pkt', label: 'Sredni wzrost wynikow', icon: 'trending' },
    { value: '8 tyg', label: 'Do widocznych rezultatow', icon: 'clock' },
  ];

  const getIcon = (type: string) => {
    switch (type) {
      case 'users':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 00-3-3.87" />
            <path d="M16 3.13a4 4 0 010 7.75" />
          </svg>
        );
      case 'check':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        );
      case 'trending':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
            <polyline points="17 6 23 6 23 12" />
          </svg>
        );
      case 'clock':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <section className="awesome-stats-section">
      <div className="awesome-stats-container">
        {stats.map((stat, index) => (
          <div key={index} className="awesome-stat-item">
            <div className="awesome-stat-icon">
              {getIcon(stat.icon)}
            </div>
            <div className="awesome-stat-content">
              <span className="awesome-stat-value">{stat.value}</span>
              <span className="awesome-stat-label">{stat.label}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SocialProofStats;
